// Call Eco API to get data
function initializeEcoSection() {
  let ecoTreeCount = 0;
  let ecoCarbonOffset = 0;

  function counter(selector, start, end, duration) {
    let obj = document.querySelector(selector);
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const tryGetEcoData = async () => {
    const response = await fetch('https://public.ecologi.com/users/heapsgoodpackaging/impact');
    const ecoData = await response.json();
    ecoTreeCount = ecoData.trees;
    ecoCarbonOffset = ecoData.carbonOffset;
  };

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  };

  function callback(entries, observer) {
    console.log('execute');
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let elem = entry.target;

        if (entry.intersectionRatio >= 0.75) {
          counter('.eco-carbon', 0, ecoCarbonOffset, 1000);
          counter('.eco-trees', 0, ecoTreeCount, 1000);
          observer.unobserve(target);
        }
      }
    });
  }

  tryGetEcoData();
  let observer = new IntersectionObserver(callback, options);
  let target = document.querySelector('.eco-section');
  observer.observe(target);
}

if (document.querySelector('.eco-section') !== null) {
  initializeEcoSection();
}

document.addEventListener('DOMContentLoaded', function () {
  const afterpayPriceSpanElement = document.querySelector('.afterpay-price');
  const unitPriceSpanElement = document.querySelector('.unit-price');
  const unitPriceWrapperElement = document.querySelector('.unit-price-wrapper');
  const quantityInputElement = document.querySelector('.variant-input-wrap[data-index="option1"]');
  const sizeInputSelectElement = document.querySelector('.variant-input-wrap[data-index="option2"]');
  const productPriceSpanElement = document.querySelector('.product__price');
  const quantityInputSelectElement = document.querySelector('.variant-input-wrap[data-index="option1"] select');

  const updateAfterpayToNewVariantPrice = () => {
    let priceAsMoneyString = productPriceSpanElement.innerHTML;
    let priceAsString = priceAsMoneyString.replace('$', '');
    priceAsString = priceAsString.replace(',', '');

    let priceAsFloat = parseFloat(priceAsString);
    let afterpayPrice = (priceAsFloat / 4).toFixed(2);
    afterpayPriceSpanElement.innerHTML = `$${afterpayPrice}`;
  };

  const updateUnitPrice = () => {
    let priceAsMoneyString = productPriceSpanElement.innerHTML;
    // The Expanse 4.1.0 theme now wraps the price in additional span elements - <span aria-hidden="true"></span>
    // ... the addtional wrapping element has to be removed for this logic to work on page load.
    let priceAsString_noOpeningSpan = priceAsMoneyString.replace('<span aria-hidden="true">', '');
    let priceAsString_noClosingSpan = priceAsString_noOpeningSpan.replace('</span>', '');
    // End of updated JS
    let priceAsString = priceAsString_noClosingSpan.replace('$', '');
    priceAsString = priceAsString.replace(',', '');
    let priceAsFloat = parseFloat(priceAsString);
    let units = parseInt(quantityInputSelectElement.value);
    let unitPrice = (priceAsFloat / units).toFixed(2);
    unitPriceSpanElement.innerHTML = `$${unitPrice}`;
  };

  const updatePrices = () => {
    if (afterpayPriceSpanElement !== null) {
      updateAfterpayToNewVariantPrice();
    }

    if (unitPriceSpanElement !== null) {
      // This function as been replaced with updated TS
      // updateUnitPrice();
    }
  };

  function inputsAreAvailable() {
    // Update price on load
    updatePrices();
    // End of updated JS
    return quantityInputElement !== null && sizeInputSelectElement !== null;
  }

  if (quantityInputElement !== null) {
    quantityInputElement.addEventListener('change', updatePrices);
  }

  if (sizeInputSelectElement !== null) {
    sizeInputSelectElement.addEventListener('change', updatePrices);
  }

  if (inputsAreAvailable()) {
    updatePrices();
  } else {
    if (unitPriceWrapperElement !== null) {
      unitPriceWrapperElement.style.display = 'none';
    }
  }
});
